import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=525ac080&"
import script from "./Balance.vue?vue&type=script&lang=js&"
export * from "./Balance.vue?vue&type=script&lang=js&"
import style0 from "./Balance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports